import React, { useState } from 'react';

function StockLogo({ src, alt = '' }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return null;
  }

  return (
    <img
      src={src}
      alt={alt}
      className="plan-stock-logo"
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}

export default StockLogo;
